import { DataTable } from "simple-datatables";

function isInPage(node) {
  return node === document.body ? false : document.body.contains(node);
}

/**
 * @see this helps https://fiduswriter.github.io/simple-datatables/documentation/
 * @param {*} container
 * @param {*} data
 * @param {*} columns ['title', 'key', 'definition']
 * @returns
 */
export default function buildDataTable(container, data, columns) {
  if (!isInPage(container)) return false;
  const headings = columns.map((c) => c["title"]),
    keys = columns.map((c) => c["key"]),
    defs = columns.map((c, i) => {
      let def = {
        select: i,
        type: "string",
      };

      if (c["type"] == "percent") {
        def.type = "number";
        def.numeric = true;
        def.render = function (data) {
          let f = Math.round(data * 100) / 100;
          return `${f}%`;
        };
      }

      if (c["type"] == "num") {
        def.type = "number";
        def.numeric = true;
        def.render = function (data) {
          return `${data.toLocaleString()}`;
        };
      }

      if (c["type"] == "rank") {
        def.type = "number";
        def.numeric = true;
        def.render = function (data) {
          return `#${data}`;
        };
      }

      if (c["type"] == "country_flag") {
        def.type = "string";
        def.render = function (data) {
          return `<span class="flag-icon flag-icon-${data.toLowerCase()}"></span>`;
        };
      }

      if (c["type"] == "change") {
        def.type = "number";
        def.numeric = true;
        def.render = function (data) {
          let c =
            data < 0 ? "sh-pill-down sh-pill-green" : "sh-pill-up sh-pill-red";
          return `<span class="sh-pill sh-pill-table ${c}">${data}%</span>`;
        };
      }

      return def;
    });

  const tabledata = data.map((item) => {
    let row = keys.map((key) => {
      if (key != "") return item[key];
    });
    return row;
  });

  const table = document.createElement("table");
  table.classList.add("sh-table");
  container.replaceWith(table);

  const datatable = new DataTable(table, {
    data: { headings: headings, data: tabledata },
    columns: defs,
    perPageSelect: false,
  });

  /** collecing 4 rows above and below, if they are there */
  function paginatorNumbers(arr, currentIndex) {
    return arr.length > 5 && currentIndex > 5
      ? arr.slice(currentIndex - 4, currentIndex + 5)
      : arr.slice(0, currentIndex + 5);
  }

  datatable.on("datatable.search", function (query, matched) {
    const rows = Array.from(
      { length: datatable.data.data.length },
      (v, i) => i
    );

    if (matched.length == 1) {
      datatable._searchData = paginatorNumbers(rows, matched[0]);
      datatable.update();
      console.log("Matched row ", matched[0]);
      console.log("Shown rows ", datatable._searchData);

      let r = table.querySelector(`tr[data-index="${matched[0]}"]`);
      r.classList.add("sh-table-row-highlight");
    }
  });

  // adds listener for the x button to clear input
  // - library only listens for keyup
  datatable.wrapperDOM
    .querySelector(".datatable-input")
    .addEventListener("search", function () {
      datatable._searchQueries = [];
      datatable.update();
    });

  /** clean highlight whenever updates */
  datatable.on("datatable.update", function () {
    const r = [].slice.call(table.querySelectorAll("tr[data-index]"));
    r.map((row) => {
      row.classList.remove("sh-table-row-highlight");
    });
  });

  return datatable;
}
